import { createMap, IOmniaContext, IOmniaHttpService, ISeedRateMapCalcPeriod, setDates } from "../exports"
import { SeedRateUnit } from "../generated/enums";
import { ISeedRatePlan, ISeedRateServiceData } from "../types"

export class SeedsLoader {

    private _supportedCrops: number[] = [];
    private _plans: ISeedRatePlan[] = [];

    constructor(private ohttp: IOmniaHttpService) {
    }


    load(ctxt: IOmniaContext): ng.IPromise<any> {

        const url = "/api/seedrates/service/data/holding/" + ctxt.holdingId + "/year/" + ctxt.yearId;

        return this.ohttp.get(url).then(r => {

            var data = r.data as ISeedRateServiceData;

            this._supportedCrops = data.SupportedCrops;
            this._plans = setupPlans(data.Plans)

        });

    }

    getSupportedSowingDates(cropId: number): ng.IPromise<ISeedRateMapCalcPeriod[]> {

        const url = "/api/seedrates/supported-dates/" + cropId

        return this.ohttp.get(url).then(r => {

            if (r.data) {
                var dates = <ISeedRateMapCalcPeriod[]>(r.data)
                return setDates(dates, ["StartDate", "EndDate"], true)
            }

        })

    }


    getPlans() {
        return this._plans.slice();
    }

    getSupportedCrops(): number[] {
        return this._supportedCrops.slice();
    }

}
function setupPlans(plans: ISeedRatePlan[]): ISeedRatePlan[] {
    return (plans ?? []).map(p => ({ ...p, Unit: p.Unit || SeedRateUnit.Kg }))
}

